import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
export const StyleAuthWrapper = styled.div`
  min-height: calc(100dvh - 75px);
  display: flex;
  align-items: center;
  padding: 30px 0px;
`
export const StyleAuthRow = styled.div`
  padding: 0px 60px;
  display: flex;
  align-items: center;
  @media (max-width: 1300px) {
    padding: 0px 0px;
  }
`
export const StyleAuthActionWrapper = styled.div<any>`
  width: 40%;
  padding: 60px 30px;
  border-radius: 12px;
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);

  @media (max-width: 1024px) {
    width: 100%;
  }
  ${(props) => props.styleWrapper}
`
export const StyleLink = styled(Link)`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.primary};
`

export const styleHalfWrapper = `
  width:49%;
  @media(max-width:640px){
    width:100%;
  }
`

export const styleRegisterButtonWrapper = `
  margin-top:30px;
  margin-bottom:10px;
  div{
    width:250px;
    button{
      width:100%;
    }
  }
  @media(max-width:640px){
    div{
      width:100%;
      button{
        width:100%;
      }
    }
  }

`

export const styleRegisterActionWrapper = `
  width:80%;
  margin:0px auto;
`
